import { render, staticRenderFns } from "./resupply-products-new.modal.vue?vue&type=template&id=b8146080&scoped=true"
import script from "./resupply-products-new.modal.vue?vue&type=script&lang=js"
export * from "./resupply-products-new.modal.vue?vue&type=script&lang=js"
import style0 from "./resupply-products-new.modal.vue?vue&type=style&index=0&id=b8146080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8146080",
  null
  
)

export default component.exports